import { useSelector } from 'react-redux';
import CreateNewTheme from '../../../../components/AssetManagement/Design/Theme/CreateNewTheme/CreateNewTheme'
import { selectUserData } from '../../../../features/userSlice';
import { useEffect } from 'react';
import { setSiteOptions } from '../../../../features/themeSlice';
import store from '../../../../store';

function CreateNewThemeScreen() {
  const response = useSelector(selectUserData);

  useEffect(() => {
    if (response?.data?.website_permissions) {
      const siteOptions = response.data.website_permissions.map(
        (siteObj: any) => {
          const uid = Object.keys(siteObj)[0]; // UID of the site
          const siteName = siteObj[uid].ui_site_name; // Site name
          return { uid, siteName }; // Return as an object with uid and siteName
        }
      );

      store.dispatch(setSiteOptions(siteOptions)); // Dispatch the memoized options
    }
  }, [response]);
  return (
    <div>
      <CreateNewTheme />
    </div>
  )
}

export default CreateNewThemeScreen
